import { defineMessages } from '@jutro/locale';

export default defineMessages({
    primaryAddress: {
        id: 'quoteandbind.bop.directives.bop-location-header.(Primary)',
        defaultMessage: '(Primary)',
    }
});
